import React from 'react';
import { X, Sparkles } from 'lucide-react';

const ChatbotIcon = ({ onClick, isOpen, showNotification, onDismissNotification }) => {
  return (
    <div className="fixed bottom-6 right-6 sm:bottom-6 sm:right-6 z-50">
      {/* Notification Popup */}
      {showNotification && !isOpen && (
        <div className="absolute bottom-20 right-0 w-64 bg-white rounded-2xl shadow-2xl border-2 border-blue-500 p-4 animate-bounce-subtle mb-2">
          <button
            onClick={onDismissNotification}
            className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X size={16} />
          </button>
          <div className="flex items-start gap-3">
            <div className="bg-gradient-to-r from-blue-500 to-sky-500 p-2 rounded-lg">
              <Sparkles size={20} className="text-white" />
            </div>
            <div>
              <h4 className="font-bold text-gray-900 text-sm mb-1">New Feature! 🎉</h4>
              <p className="text-gray-600 text-xs leading-relaxed">
                Chat with our AI assistant to learn about ThinkVerse.AI!
              </p>
            </div>
          </div>
          <div className="absolute -bottom-2 right-8 w-4 h-4 bg-white border-r-2 border-b-2 border-blue-500 transform rotate-45"></div>
        </div>
      )}

      {/* Chatbot Icon Button */}
      <button
        onClick={onClick}
        className={`relative bg-gradient-to-r from-blue-500 to-sky-500 hover:from-sky-500 hover:to-blue-500 text-white p-4 rounded-full shadow-2xl hover:shadow-blue-500/50 transition-all duration-300 hover:scale-110 ${isOpen ? 'scale-0' : 'scale-100'
          }`}
        aria-label="Open chatbot"
      >
        {/* Pulse animation ring */}
        {showNotification && (
          <span className="absolute inset-0 rounded-full bg-blue-500 animate-ping opacity-75"></span>
        )}

        <img
          src="https://customer-assets.emergentagent.com/job_intelligent-home-1/artifacts/w793r8mv_ThinkVerse.AI%20%282%29.png"
          alt="ThinkVerse.AI"
          className="w-8 h-8 object-contain relative z-10"
          style={{ filter: 'brightness(10) contrast(1.2)' }}
        />

        {/* New badge */}
        {showNotification && (
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full animate-pulse">
            NEW
          </span>
        )}
      </button>
    </div>
  );
};

export default ChatbotIcon;
